module.exports = __webpack_public_path__ + "img/4Z.e437dc01.png";